export default "__VITE_ASSET__CC9O0wOu__"